import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_VOCABULARY_RESULTS_REQUEST = 'FETCH_VOCABULARY_RESULTS_REQUEST';
export const FETCH_VOCABULARY_RESULTS_SUCCESS = 'FETCH_VOCABULARY_RESULTS_SUCCESS';
export const FETCH_VOCABULARY_RESULTS_FAILURE = 'FETCH_VOCABULARY_RESULTS_FAILURE';

const buildVocabularyUrl = (groupId) => buildUrl(`/groups/${groupId}/vocabulary-results`);

export function fetchVocabularyIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildVocabularyUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchVocabulary(groupId));
  };
}

export function fetchVocabulary(groupId) {
  return (dispatch) => {
    const url = buildVocabularyUrl(groupId);
    const method = 'GET';

    return dispatch(fetchVocabularyRequest()).payload
      .then((response) => dispatch(fetchVocabularySuccess(response)))
      .catch((error) => dispatch(fetchVocabularyFailure(error)));

    function fetchVocabularyRequest() {
      return ApiCall.createAction({
        type: FETCH_VOCABULARY_RESULTS_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchVocabularySuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_VOCABULARY_RESULTS_SUCCESS,
        payload,
        url,
        method,
        groupId,
      });
    }

    function fetchVocabularyFailure(error) {
      return ApiCall.createAction({
        type: FETCH_VOCABULARY_RESULTS_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Vocabulary/actions.js